const words = ["CAMP", "STAMP", "REPEAT"];

/**
 * Static, always-visible motto.
 * The subtle pulse loop lives on the wrapper via .motto-pulse.
 * Entrance is handled cheaply so the words are guaranteed to render.
 */
export default function Motto() {
  return (
    <div className="motto motto-pulse motto-enter" data-testid="hero-motto">
      {words.map((w, i) => (
        <span key={w} className="inline-flex items-center gap-4 md:gap-6">
          <span
            className="motto-word-stagger"
            style={{ animationDelay: `${0.1 + i * 0.15}s` }}
          >
            {w}
          </span>
          {i < words.length - 1 && (
            <span className="motto-dot">.</span>
          )}
        </span>
      ))}
    </div>
  );
}
